import { ActionTypes } from '../../constants';

let defaultState = {
  cpiConfig: ''
}

function ConfigReducer (state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.ADD_CPI_CONFIG:

      return { ...state, cpiConfig: action.payload.cpiConfig };
    default:
      return state;
  }
}

export default ConfigReducer;